module.exports = __webpack_public_path__ + "static/media/redux.09929596.jpg";